var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var snakeToCamelCase = /* @__PURE__ */ __name(function snakeToCamelCase2(str) {
  return str.replace(/([-_][a-z0-9])/g, function(group) {
    return group.toUpperCase().replace("-", "").replace("_", "");
  });
}, "snakeToCamelCase");
export {
  snakeToCamelCase
};
